import { Component, OnInit, Inject, Injector, HostListener, OnDestroy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { DocumentService } from '../../../../ve.service';
import { FileUploadService } from '../../../work-order-file-upload/file-upload.service';
import { WorkOrderFileUploadComponent } from '../../../work-order-file-upload/work-order-file-upload.component';

@Component({
  selector: 'ga-upload-file-dialog',
  templateUrl: './ga-upload-file-dialog.component.html',
})
export class GaUploadFileDialogComponent extends WorkOrderFileUploadComponent implements OnInit, OnDestroy {
  data: any = {};
  form: UntypedFormGroup;
  formBuilder: UntypedFormBuilder;
  fileUploadService: FileUploadService;
  documentService: DocumentService;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<GaUploadFileDialogComponent>,
    private readonly injector: Injector
  ) {
    super(injector);
    this.fileUploadService = this.injector.get(FileUploadService);
    this.documentService = injector.get(DocumentService);
    this.formBuilder = this.injector.get(UntypedFormBuilder);
    this.data = data;
    this.form = this.formBuilder.group({
      DocumentName: [],
      Description: [],
      WorkOrderId: [],
      DocumentTypeId: [],
      AddInfoCategoryId: [],
      File: []
    });
  }

  ngOnInit() {
    this.fileUploadService.uploadSaveUrl = this.documentService.getUploadUrl('VE_GA', false);
    this.fileUploadService.fileType = this.data.fileType;
    this.fileUploadService.addInfoCategoryId = this.data.addInfoCategoryId;
    Promise.all([
      this.fileUploadService.getFiles()
    ]);
  }

  onCloseClick(): void {
    this.dialogRef.close(this.fileUploadService.kendoFileList);
  }

  ngOnDestroy() {
    this.fileUploadService.kendoFileList = [];
  }
}
